import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon, CheckIcon, FileCheckIcon } from "lucide-react";
import type { UpcomingPage } from "../types/content";
type ComingSoonProps = {
  page: UpcomingPage;
};
export function ComingSoon({
  page
}: ComingSoonProps) {
  return <section className="w-full bg-ink text-white" data-id="element-201" data-mp="3vh4vba2jrf7q">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-4xl flex-col items-center justify-center px-5 py-20 text-center md:px-8" data-id="element-202" data-mp="3vfk1jmo240ax">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-lime text-ink" data-id="element-203" data-mp="99wvenaec0j3">
          <FileCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-204" data-mp="n0s7e8g6yxqw" />
        </span>
        <h1 className="mt-8 text-5xl font-semibold leading-[1.02] tracking-tightest md:text-7xl" data-id="element-205" data-mp="n2w9ckuj5moj">
          {page.title}
        </h1>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-206" data-mp="wyg4h519shc8">
          Cette page sera conçue et développée{" "}
          <span className="font-medium text-lime" data-id="element-207" data-mp="s1pmgc5wnbo6">après validation du devis</span>.
          Seule la page d'accueil est présentée dans cette maquette.
        </p>

        <div className="mt-12 w-full max-w-md rounded-2xl border border-white/15 p-7 text-left" data-id="element-208" data-mp="124bagwgzwi9l">
          <h2 className="text-sm font-semibold text-white/60" data-id="element-209" data-mp="166eyekkupfbr">Contenu prévu</h2>
          <ul className="mt-4 space-y-3" data-id="element-210" data-mp="1b5j8ddflnh35">
            {page.planned.map(item => <li key={item} className="flex items-start gap-3" data-id="element-211" data-mp="1g4vt9smwue33">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-lime" aria-hidden="true" data-id="element-212" data-mp="1g4cj4y3i4tzm" />
                <span className="text-white/90" data-id="element-213" data-mp="1l2e3dmcnyzco">{item}</span>
              </li>)}
          </ul>
        </div>

        <Link to="/" className="mt-10 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-lime px-7 py-3.5 font-medium text-ink transition-colors duration-150 ease-out hover:bg-lime-hover" data-id="element-214" data-mp="1pws320yczsn5">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-215" data-mp="23u6v7dfzyeit" />
          Retour à l'accueil
        </Link>
      </div>
    </section>;
}